import { createStore } from "./store.ts";

export type ToastKind = "info" | "success" | "error" | "pending";

export interface Toast {
  /** The DEDUPE KEY, and the reason toasts are keyed at all: an order's pending toast must be REPLACED by its
   *  result rather than stacked beside it, so a user never sees "Submitted…" and "Filled" for one trade. */
  key: string;
  kind: ToastKind;
  text: string;
  /** An optional explorer link. Never a raw signature in the text — the link carries it. */
  href?: string;
  /** ms; `null` means sticky and dismissed only by a later toast with the same key, or by the user. */
  ttlMs: number | null;
}

export const toastStore = createStore<readonly Toast[]>([]);

/** Push or REPLACE by key. Replacement in place is the whole point — see `Toast.key`. */
export function pushToast(toast: Toast): void {
  toastStore.set((prev) => {
    const without = prev.filter((t) => t.key !== toast.key);
    return [...without, toast];
  });
}

export function dismissToast(key: string): void {
  toastStore.set((prev) => {
    const next = prev.filter((t) => t.key !== key);
    // Same length ⇒ nothing was removed ⇒ return the SAME reference so `createStore` treats it as a no-op and
    // no subscriber wakes. Returning a fresh array here would re-render the toast host on every stray dismiss.
    return next.length === prev.length ? prev : next;
  });
}
